import React from 'react';
import { View, TextInput, Text as RNText } from 'react-native';
import { useNodeMeasurer, useStyleSheet, useThemeContext } from '../../hooks';
import { createStyleSheet } from '../../utils';
import { Text } from '../Text';
export const MoneyInput = React.forwardRef(({ value, onChange, style, onEnter, autoFocus, max = 999999 }, ref) => {
    const styles = useStyleSheet(getStyles);
    const { dimensions, onLayout } = useNodeMeasurer();
    const { color } = useThemeContext();
    return (React.createElement(View, { style: [styles.container, style] },
        React.createElement(View, { style: styles.inputWrapper },
            React.createElement(Text, { style: styles.dollarSign, type: 'heading', size: 'h5' }, "$"),
            React.createElement(View, null,
                React.createElement(RNText, { style: styles.hiddenValue, selectable: false, onLayout: onLayout }, value === '' ? '0' : value),
                React.createElement(TextInput, { ref: ref, keyboardType: 'decimal-pad', style: [styles.input, { width: dimensions.width }], placeholder: '0', placeholderTextColor: color.invert2.p26, onSubmitEditing: onEnter, autoFocus: autoFocus, value: value.toString(), onChangeText: (value) => {
                        const next = value.trim();
                        if (!Number.isNaN(Number(next)) && Number(next) <= max)
                            onChange(next);
                    } })))));
});
MoneyInput.displayName = 'MoneyInput';
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: size.C
    },
    inputWrapper: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'center'
    },
    hiddenValue: {
        fontSize: size.M,
        position: 'absolute',
        opacity: 0,
        lineHeight: 53,
        zIndex: -1,
        fontFamily: 'Satoshi',
        fontWeight: '700'
    },
    input: {
        fontSize: size.M,
        color: color.invert2.p100,
        fontFamily: 'Satoshi',
        fontWeight: '700'
    },
    dollarSign: {
        color: color.invert2.p100,
        top: size.D,
        left: -size.G,
        position: 'absolute'
    }
}));
//# sourceMappingURL=index.js.map